import { render, staticRenderFns } from "./certifications.vue?vue&type=template&id=369cf23a&scoped=true&"
import script from "./certifications.vue?vue&type=script&lang=js&"
export * from "./certifications.vue?vue&type=script&lang=js&"
import style0 from "./certifications.vue?vue&type=style&index=0&id=369cf23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369cf23a",
  null
  
)

export default component.exports